"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiskTreeElement = void 0;
var utils_1 = require("./utils");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var controlTreeElement_1 = require("./controlTreeElement");
var tableRowElementCheckbox_1 = require("./tableRowElementCheckbox");
var typestyle_1 = require("typestyle");
var buttons_1 = require("../buttons");
var tableRowElement_1 = require("./tableRowElement");
var generic_1 = require("../generic");
var RiskTreeElement = (function (_super) {
    __extends(RiskTreeElement, _super);
    function RiskTreeElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RiskTreeElement.prototype.render = function () {
        var _this = this;
        var risk_element = this.props.risk;
        var risk = risk_element.risk;
        var key = this.props.parent_id;
        var htmlID = (0, utils_1.getRiskId)(risk_element);
        var controls = risk_element.controls
            .filter(function (control_element) {
            if (!_this.props.filterElements) {
                return true;
            }
            var isFiltered = _this.props.isControlFilteredOut && _this.props.isControlFilteredOut(control_element);
            var allChildrenAreFiltered = _this.props.controlHasNoActiveChildren(control_element);
            return (!isFiltered || !allChildrenAreFiltered);
        })
            .map(function (control_element) {
            var isFiltered = _this.props.isControlFilteredOut && _this.props.isControlFilteredOut(control_element);
            var allChildrenAreFiltered = _this.props.controlHasNoActiveChildren(control_element);
            return React.createElement(controlTreeElement_1.ControlTreeElement, { parent_id: htmlID, key: key, control: control_element, showCheckbox: _this.props.showCheckbox, isChecked: _this.props.isChecked, inputChangeHandler: _this.props.inputChangeHandler, filterElements: _this.props.filterElements, isActionFilteredOut: _this.props.isActionFilteredOut, overWritingFilter: _this.props.filterElements && isFiltered && !allChildrenAreFiltered, addNodeIcon: _this.props.addNodeIcon, onClick: _this.props.onClickControl, onClickAction: _this.props.onClickAction, onAddActionClicked: _this.props.onAddActionClicked });
        });
        var label_props = {
            project_title: risk.project_title,
            number: "".concat(get_term('Risk'), " #").concat(risk.risk_number),
            title: risk.title,
            owner: risk.owner,
            status_display: risk.status_display,
            elementType: tableRowElement_1.ElementTypes.risk,
        };
        var baseClass = "TreeElement";
        var colorClass = (risk.is_owned === false ||
            this.props.filterElements && this.props.overWritingFilter ?
            "table-info" :
            "table-primary");
        var hoverClass = baseClass + (this.props.onClick ? "--hoverable" : "--not-hoverable");
        var classNames = (0, typestyle_1.classes)(baseClass, hoverClass, "TreeElement--NoBorder");
        return (React.createElement(React.Fragment, null,
            React.createElement("tr", { className: classNames, onClick: function (event) {
                    _this.props.onClick && _this.props.onClick(risk_element);
                } },
                React.createElement(tableRowElementCheckbox_1.TableRowElementCheckbox, { id: htmlID, name: "risks", value: risk.id.toString(), showCheckbox: this.props.showCheckbox, disabled: risk.is_owned === false || this.props.overWritingFilter, label_props: label_props, isChecked: this.props.isChecked, inputChangeHandler: this.props.inputChangeHandler, colorClass: colorClass }),
                this.props.addNodeIcon && (React.createElement("td", { className: colorClass },
                    React.createElement(buttons_1.ActionButton, { className: "btn btn-link add_control p-0", title: get_term("Quick add a control"), onClick: function (e) {
                            e.stopPropagation();
                            _this.props.onAddControlClicked && _this.props.onAddControlClicked(risk_element);
                        } },
                        React.createElement(generic_1.Icon, { name: generic_1.Icons.plus_circle }))))),
            controls));
    };
    RiskTreeElement = __decorate([
        mobx_react_1.observer
    ], RiskTreeElement);
    return RiskTreeElement;
}(React.Component));
exports.RiskTreeElement = RiskTreeElement;
